// Hero image
export const heroImage = './assets/images/hero/hero.jpg';

// Logo
export const logo = './assets/images/logo/logo.png'; 